import { type KPI } from "../../../types/kpiTypes"

const createCSVString = (kpis: KPI[]): string => {
  const dateSet = new Set<string>()
  kpis.forEach((kpi) => {
    kpi.values?.forEach((val) => dateSet.add(val.date))
  })
  const dates = Array.from(dateSet).sort()

  const headers = ["Date", ...kpis.map((kpi) => kpi.name)]

  const kpiValueMap: Record<number, Record<string, number | undefined>> = {}
  kpis.forEach((kpi, index) => {
    kpiValueMap[index] = {}
    kpi.values?.forEach((val) => {
      if (val.type == "Actual") {
        kpiValueMap[index][val.date] = Math.round(val.value * 100) / 100
      }
    })
  })

  const rows = dates.map((date) => {
    const values = kpis.map((_, index) => {
      const val = kpiValueMap[index][date]
      return val !== undefined ? val : ""
    })
    return [date, ...values].join(",")
  })
  const unitRow = ["Units", kpis.map((kpi) => kpi.unit)]
  return [headers.join(","), unitRow, ...rows].join("\n")
}
export const downloadKPIExport = (data: KPI[], filename: string) => {
  const csv = createCSVString(data)
  const blob = new Blob([csv], { type: "text/csv" })
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
